import React, { useState, Suspense, useEffect } from "react";
import styled from "styled-components";
import { useComponentVisible } from "./hooks";
import { Modal } from '@mui/material';
import checkListEmojiJpg from "../../utils/assets/images/checkList_Emoji.jpg";

const Picker = React.lazy(() => import('@emoji-mart/react'));

const EmojiButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
`;
const EmojiWrapper = styled.div`
  //   position: absolute;
  //   bottom: ${(p) => (p.bottom ? p.bottom : "60px")};
  //   overflow: visible;
`;
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
//   padding-top: 5px;
`;

export default function CheckListEmoji({ imageUrl, onEmojiClick, bottom = "60px" }) {
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);
  const [open, setOpen] = useState(false);
  const [emojiData, setEmojiData] = useState(null);

  useEffect(() => {
    if (open && !emojiData) {
      import('@emoji-mart/data').then(module => {
        setEmojiData(module.default);
      });
    }
  }, [open, emojiData]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleTouchOpen = (event) => {
    event.preventDefault();
    handleOpen();
  }

  return (
    <Wrapper>
      <Modal open={open} onClose={handleClose} className="checkListEmojiModal">
        <EmojiWrapper ref={ref} bottom={bottom}>
          {emojiData && (
            <Suspense fallback={<div style={{ textAlign: 'center', padding: '20px' }}>Loading emoji picker...</div>}>
              <Picker
                data={emojiData}
                onEmojiSelect={(val) => {
                  handleClose()
                  onEmojiClick(val)
                }}
                theme="light"
                previewPosition="none"
                style={{ height: 300, width: 250 }}
              />
            </Suspense>
          )}
        </EmojiWrapper>
      </Modal>
      <EmojiButton onClick={() => handleOpen()} onTouchStart={handleTouchOpen} >
        {imageUrl ? (
          <span>{imageUrl}</span>
        ) : (
          <img
            src={checkListEmojiJpg}
            alt=""
          />
        )}
      </EmojiButton>
    </Wrapper>
  );
}
